<i18n lang="yaml">
  ru:
    ActionPreviewAnimationLabel: "Анимация"
  en:
    ActionPreviewAnimationLabel: "Animation"
</i18n>

<template>
  <div :class="$style.actionPreview">
    <header :class="$style.actionPreviewHeader">
      <PWDeviceToggle
        v-model="previewTypeLocal"
      />
    </header>
    <div>
      <ActionPreviewTypeDesktop
        v-if="previewTypeLocal === 'desktop'"
      >
        <slot />
      </ActionPreviewTypeDesktop>
      <ActionPreviewTypeMobile
        v-if="previewTypeLocal === 'mobile'"
      >
        <slot />
      </ActionPreviewTypeMobile>
    </div>
    <footer :class="$style.actionPreviewFooter">
      <PWButton
        variant="outline"
        size="medium"
      >
        <PlayCircleRounded :class="$style.actionPreviewFooterIcon" />
        <span>
          {{ $t('ActionPreviewAnimationLabel') }}
        </span>
      </PWButton>
    </footer>
  </div>
</template>

<script>
/**
 * UI
 */
import PWDeviceToggle from '@/components/_ui/Pickers/PWDeviceToggle.vue'
import ActionPreviewTypeDesktop from '@/components/Actions/ActionPreview/ActionPreviewTypeDesktop.vue'
import ActionPreviewTypeMobile from '@/components/Actions/ActionPreview/ActionPreviewTypeMobile.vue'
import PWButton from '@/components/_ui/Buttons/PWButton.vue'
/**
 * Static
 */
import PlayCircleRounded from '@/assets/icons/PlayCircleRounded.svg?inline'

export default {
  components: {
    PWDeviceToggle,
    ActionPreviewTypeDesktop,
    ActionPreviewTypeMobile,
    PWButton,
    PlayCircleRounded
  },
  props: {
    previewType: {
      type: String,
      default: 'desktop'
    }
  },
  computed: {
    previewTypeLocal: {
      get () { return this.previewType },
      set (val) { this.$emit('update-previewType', val) }
    }
  }
}
</script>

<style module lang="scss">
.actionPreview {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 40px;
  padding-right: 32px;
}

.actionPreviewHeader,
.actionPreviewFooter {
  display: flex;
  justify-content: center;
}

.actionPreviewFooterIcon {
  --s: 20px;

  width: var(--s);
  height: var(--s);
}
</style>
